export default __webpack_public_path__ + "static/solomon2-92fa72e7ec8283f9c018f3267bf097f5.png";